import React, { Component } from 'react';
import { connect } from 'react-redux';
import subtotalSalesTax from '../../selectors/subtotalSalesTax.selector';
import TextInput from '../../components/TextInput';

class SubtotalSalesTax extends Component {
  render() {
    const { subtotalSalesTax } = this.props;
    return (
      <div className="Row Row-paddedBottom">
        <TextInput tabIndex="-1" className="Row-subtotal" id="STotal" tooltip="Subtotal of Sales Taxes" value={subtotalSalesTax || '0.00'} readOnly />
        <label className="Row-totalHeadingLabel" htmlFor="Rsubsub" data-tooltip="Subtotal of Registration fees minus credit">TOTAL TAXES</label>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subtotalSalesTax: subtotalSalesTax(state),
  };
};

export default connect(mapStateToProps)(SubtotalSalesTax);
